import Modal from 'LuxKit/Modal/Modal'
import React, { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'
import TripPanel from './TripPanel'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import { useTrips } from 'tripPlanner/hooks/api/trip'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { EmptyArray, sortBy } from 'lib/array/arrayUtils'
import type { BasicTrip } from 'tripPlanner/types/common'

interface Props {
  onSelectTrip: (tripId: string) => void
}

function TripSelect({ onSelectTrip }: Props) {
  const intl = useIntl()
  const { data: trips = EmptyArray as Array<BasicTrip>, isLoading, isError, isFetched } = useTrips()
  const sortedTrips = useMemo(() => {
    return sortBy(trips, (trip) => trip.interactedAt, 'desc')
  }, [trips])

  const modal = useModalElementContext()

  const onClose = useCallback(() => {
    modal.resolve()
  }, [modal])

  const selectAndClose = useCallback(
    (tripId: string) => {
      onSelectTrip(tripId)
      onClose()
    },
    [onClose, onSelectTrip],
  )

  return (
    <Modal
      title={intl.formatMessage({
        id: 'rjqKXUNF2x',
        defaultMessage: 'Select trip',
        description: 'Modal title for trip selection',
      })}
      subtitle={intl.formatMessage({
        id: 'aiqPR13rNf',
        defaultMessage: 'Choose which trip you would like to preview.',
        description: 'Modal subtitle for trip selection',
      })}
      onClose={onClose}
    >
      {isError && <div>
        {intl.formatMessage({
          id: 'DhRkQvEWRg',
          defaultMessage: 'Failed to fetch trips',
          description: 'Error message when trips cannot be loaded',
        })}
      </div>}
      {isLoading && <LoadingIndicator inline />}
      {isFetched && sortedTrips.map((trip) => (
        <TripPanel key={trip.id} onSelectTrip={selectAndClose} trip={trip} />
      ))}
    </Modal>
  )
}

export default TripSelect
